import Loading from "components/Loading";
import NoData from "components/NoData";
import PhoneInputAuth from "components/PhoneInputAuth";
import Dashboard from "components/Template/Dashboard";
import TextInputAuth from "components/TextInputAuth";
import toastMessage from "helpers/handleToastMessage";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { listEntityById } from "services/entity";
import { listPlan } from "services/plan";
import { Plan } from "types/plan";
import { getPlansWithDiscounts } from "utils/getPlansWithDiscount";
import ShowPlans from "./ShowPlans";

type Props = {};

const EntityShow: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [loading, setLoading] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [valueMonth, setValueMonth] = useState<any>();
  const [valueOneTime, setValueOneTime] = useState<any>();

  const listEntity = async (id: string) => {
    try {
      setLoading(true);
      const { data } = await listEntityById(id);
      setName(data.name);
      setPhone(data.phone);
      setAddress(data.address);
      setEmail(data.email);
      await validCoupon(data?.coupon || "");
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const validCoupon = async (sendCoupon: string) => {
    try {
      setLoadingCoupon(true);
      const { data } = await listPlan();

      const plans: Plan[] = await getPlansWithDiscounts({
        currentPlans: data.Plans.filter(
          (plan: any) => plan.id !== "price_1PvH7gBYagSIczaot9LJtvaP"
        ),
        coupon: sendCoupon,
      });

      plans.forEach((plan) => {
        const unitAmount = plan.unit_amount;

        if (plan.type === "one_time") {
          setValueOneTime(
            unitAmount
              .toString()
              .slice(0, -2)
              .concat(`.${unitAmount.toString().slice(-2)}`)
          );
        }
        if (plan.type === "recurring") {
          setValueMonth(
            unitAmount
              .toString()
              .slice(0, -2)
              .concat(`.${unitAmount.toString().slice(-2)}`)
          );
        }
      });
    } catch (error: any) {
    } finally {
      setLoadingCoupon(false);
    }
  };

  useEffect(() => {
    setId(history.location.pathname.split("/")[2]);
    if (id) {
      listEntity(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, id]);

  return (
    <Dashboard
      icon={ArrowLeft}
      title={name}
      breadcrumb={[
        {
          name: "Entity Management",
          active: false,
          path: "/entity-management",
        },
        { name: name, active: true },
      ]}
      children={
        <div>
          <Loading loading={loading || loadingCoupon} />
          <ToastContainer />
          {name || email || phone || address ? (
            <div className="bg-bt-white p-6">
              <div className="flex flex-row p-2">
                <div className="flex flex-col w-1/2 mr-2">
                  <TextInputAuth
                    placeholder={"Entity name"}
                    label="Entity name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="flex flex-col w-1/2 ml-2">
                  <TextInputAuth
                    placeholder={"Email"}
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="flex flex-row p-2">
                <div className="flex flex-col w-1/2 mr-2">
                  <PhoneInputAuth
                    placeholder={"Phone"}
                    label="Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <div className="flex flex-col w-1/2 ml-2">
                  <TextInputAuth
                    placeholder={"Address"}
                    label="Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
              </div>
              <ShowPlans
                valueMonth={valueMonth}
                valueOneTime={valueOneTime}
                entityId={id}
              />
            </div>
          ) : (
            <NoData />
          )}
        </div>
      }
    />
  );
};

export default EntityShow;
